import React from 'react';

const CircleInfo = () => {
  return (
    <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#h5eb3n8f8a)">
        <path
          d="M100 0C44.766 0 0 44.766 0 100s44.766 100 100 100 100-44.766 100-100S155.234 0 100 0zm0 187.5c-48.242 0-87.5-39.258-87.5-87.5S51.758 12.5 100 12.5s87.5 39.258 87.5 87.5-39.258 87.5-87.5 87.5zm0-115.625a9.375 9.375 0 1 0 0-18.75 9.365 9.365 0 0 0-9.375 9.375A9.353 9.353 0 0 0 100 71.875zm18.75 65.625h-12.5V93.75c0-3.438-2.812-6.25-6.25-6.25H87.5c-3.438 0-6.25 2.813-6.25 6.25 0 3.438 2.813 6.25 6.25 6.25h6.25v37.5h-12.5c-3.438 0-6.25 2.812-6.25 6.25s2.813 6.25 6.25 6.25h37.5a6.25 6.25 0 0 0 6.25-6.25c0-3.438-2.812-6.25-6.25-6.25z"
          fill="#A6A6A6"
        />
      </g>
      <defs>
        <clipPath id="h5eb3n8f8a">
          <path fill="#fff" d="M0 0h200v200H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CircleInfo;
